import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Icon from "../../../components/Detail/Icons";
import Remote from "../../LoaderRemote";
import Skeleton from "react-loading-skeleton";
import PaymentOptions from "../../Reservation/PaymentOptions";
import Title from "../../Reservation/Title";
import FastReservation from "../../FastReservation";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import { Formik } from "formik";
import { ReservationShema } from "../../../validations";
import TextInput from "../../Reservation/TextInput";
import PhoneInputW from "../../Reservation/PhoneInput";
import SendBtn from "../../Reservation/SendBtn";
import Contract from "../../Reservation/Contract";
import { SendReservation } from "../../api";
import { toast } from "react-toastify";
import * as criteo from "../../../scripts/criteo";
import { useTranslation } from "../../../context/TranslationContext";
import BackButton from "../../BackButton";
import DiscountBannerMobile from "../../DiscountBannerMobile";
import KiralaGelBanner from "../../KiralaGelBanner";

const Index = ({ page, isAppWebView, deviceType }) => {
  const {
    reservationSection1Title,
    reservationFormNamePlaceholder,
    reservationFormEmailPlaceholder,
    reservationFormPhonePlaceholder,
    reservationFormPhonePlaceholder2,
    reservationSection3Title,
    reservationDamageDeposit,
    reservationDamageDepositDescription,
    reservationCheckinCheckoutTime,
    reservationCheckinTime,
    reservationCheckoutTime,
    inludedPrice,
    contract1,
    contract2,
  } = useTranslation();
  const [isLoading, setisLoading] = useState(1);
  const [reservationResult, setreservationResult] = useState(false);
  const router = useRouter();
  const [error, setError] = useState(false);
  const { SuccessPage } = page;

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  useEffect(() => {
    setisLoading(0);
  }, []);

  const setParam = (obj) => {
    const { query } = router;
    for (const [key, value] of Object.entries(obj)) {
      query[key] = value;
    }
    query.slug = [page.url];
    router.replace(
      {
        query: query,
      },
      undefined,
      {
        scroll: false,
        shallow: true,
      },
    );
  };

  const SqlDate = (d) => {
    let a = d.split("-");
    return a[2] + "." + a[1] + "." + a[0];
  };

  const { reservationTitle, person, bedRoom, bathRoom } = useTranslation();

  return (
    <>
      <div className="bg-[#EFF5F7] pt-8 relative  pb-44">
        <div className="container flex flex-col items-start lg:flex-row">
          <div className="w-full lg:w-[300px] xl:w-[381px] mr-12 flex flex-col z-10 static lg:sticky top-1 ">
            <BackButton isAppWebView={isAppWebView} />
            <div className="relative w-full h-52">
              {isLoading ? (
                <Skeleton height={207}></Skeleton>
              ) : (
                <Image
                  src={page.Product.resim}
                  loader={Remote}
                  alt={page.Product.title}
                  objectFit={"cover"}
                  sizes="(max-width: 1024px) 100vw,
          (max-width: 1280px) 300px,
          400px"
                  layout={"fill"}
                />
              )}
            </div>
            {!isLoading && (
              <FastReservation
                setreservationResult={setreservationResult}
                setParam={setParam}
                id={page.Product.id}
                kisi={page.Product.kisi}
                paymentType={page?.Product?.paymentType}
                isAppWebView={isAppWebView}
                deviceType={deviceType}
              />
            )}
            <div className="hidden lg:block">
              <KiralaGelBanner
                src="/images/kiralagel-banner/575x260.png"
                deviceType={deviceType}
              />
            </div>
          </div>

          <div className="z-0 flex-1">
            <div className="mt-3 bg-white p-3 rounded-md text-center lg:text-left lg:mt-0 lg:bg-transparent lg:rounded-none lg:p-0 flex flex-col before:content-[''] before:absolute before:bg-white before:left-0 before:top-0 before:w-full before:h-60 before:-z-1">
              <h1 className="pt-[30px] pb-10 text-lg lg:text-2xl">
                {isLoading ? (
                  <Skeleton height={33}></Skeleton>
                ) : (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: reservationTitle.replace(
                        "{baslik}",
                        page.Product.baslik,
                      ),
                    }}
                  ></span>
                )}
              </h1>
              <hr className="bg-[#EDF0F2] h-0.5"></hr>
              <div className="flex flex-col items-center mt-7 lg:flex-row">
                {isLoading ? (
                  <>
                    <div className="flex-50">
                      <Skeleton height={33}></Skeleton>
                    </div>
                    <div className="ml-auto">
                      <Skeleton height={33} width={100}></Skeleton>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex flex-col items-center mb-5 lg:items-start lg:mb-0">
                      <strong className="text-black text-[22px] lg:text-base xl:text-[22px]">
                        {page.Product.baslik}
                      </strong>
                      <div className="flex md:mt-2 lg:mt-0">
                        <span className="font-bold text-13 lg:text-sm opacity-50 !leading-none">
                          {page.Product.destination}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between lg:ml-5 xl:ml-24 gap-x-4 lg:gap-x-14 mb-7 lg:mb-0">
                      <div className="flex items-center justify-items-center ">
                        <div className="iconsImgFilter">
                          <Icon name={"VillaItemProp1"}></Icon>
                        </div>
                        <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2">
                          <span>{page.Product.kisi}</span>
                          <span>{person}</span>
                        </div>
                      </div>
                      <div className="flex items-center justify-items-center">
                        <div className="iconsImgFilter">
                          <Icon name={"VillaItemProp2"}></Icon>
                        </div>
                        <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2">
                          <span>{page.Product.yatak_odasi}</span>
                          <span>{bedRoom}</span>
                        </div>
                      </div>
                      <div className="flex items-center justify-items-center">
                        <div className="iconsImgFilter">
                          <Icon name={"VillaItemProp3"}></Icon>
                        </div>
                        <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2">
                          <span>{page.Product.banyo}</span>
                          <span>{bathRoom}</span>
                        </div>
                      </div>
                    </div>
                    {/* <Link href={"/" + page.Product.url}>
                      <a
                        title={page.Product.title}
                        className="font-bold text-black underline lg:ml-auto"
                      >
                        Villa Detayları
                      </a>
                    </Link> */}
                  </>
                )}
              </div>
            </div>

            <Formik
              initialValues={{
                name: "",
                email: "",
                phone: "",
                phoneIsValid: false,
                phone2: "",
                phoneIsValid2: false,
                identityNumber: "",
                firstPayment: 1,
                paymentMethod:
                  reservationResult?.BookableDirectly == "1" ? 1 : 2,
                sozlesme: false,
                kvkk: false,
                directly: 0,
              }}
              validationSchema={ReservationShema}
              onSubmit={(values, actions) => {
                SendReservation(
                  {
                    EntityId: router.query.ProductId,
                    start: router.query.start,
                    end: router.query.end,
                    yetiskin: router.query.yetiskin,
                    cocuk: router.query.cocuk,
                    bebek: router.query.bebek,
                    PromotionCode: localStorage.getItem("PromotionCode")
                      ? localStorage.getItem("PromotionCode")
                      : isAppWebView
                        ? "MobilApp.1000"
                        : "",
                    pool_fee: router.query.buyPool,
                    selectedServices: router.query.selectedServices,
                    isAppWebView: isAppWebView ? 1 : 0,
                  },
                  values,
                )
                  .then((response) => {
                    if (response.data.error) {
                      toast.error(response.data.error);
                    } else {
                      criteo.sendReservation(
                        values.email,
                        SqlDate(router.query.start),
                        SqlDate(router.query.end),
                        parseInt(router.query.yetiskin) +
                          parseInt(router.query.cocuk),
                        response.data.id,
                        response.data.deposit_price,
                      );

                      if (response.data?.redirectTo) {
                        router.push(response.data.redirectTo);
                        return;
                      }

                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({
                            type: "PAYMENT_SUCCESS",
                            reservationId: response.data.id,
                          }),
                        );
                      }

                      setTimeout(() => {
                        router.push({
                          pathname: "/" + SuccessPage.url,
                          query: {
                            q: response.data.hash,
                          },
                        });
                      }, 300);
                    }
                    actions.setSubmitting(false);
                  })
                  .catch((error) => {
                    toast.error(error.message);
                    actions.setSubmitting(false);
                  });
              }}
            >
              {(props) => (
                <form className="mt-20" onSubmit={props.handleSubmit}>
                  <div>
                    {!isAppWebView && (
                      <div className="hidden sm:block mb-10">
                        <DiscountBannerMobile src="/images/discount-banner-mobile.png" />
                      </div>
                    )}
                    <Title>{reservationSection1Title}</Title>
                    <div className="grid gap-2 mt-8 sm:grid-cols-2">
                      <TextInput
                        className="w-full py-3 text-sm font-semibold outline-none peer"
                        placeholder={reservationFormNamePlaceholder}
                        name="name"
                        isrequired="required"
                      ></TextInput>
                      <TextInput
                        className="w-full py-3 text-sm font-semibold outline-none peer"
                        placeholder={reservationFormEmailPlaceholder}
                        name="email"
                        type="email"
                        isrequired="required"
                      ></TextInput>

                      <PhoneInputW
                        name="phone"
                        validname="phoneIsValid"
                        label={reservationFormPhonePlaceholder}
                        isrequired="required"
                      ></PhoneInputW>

                      <PhoneInputW
                        name="phone2"
                        validname="phoneIsValid2"
                        label={reservationFormPhonePlaceholder2}
                      ></PhoneInputW>

                      {/* <div className="h-[70px] flex items-center">
                        <div className="relative">
                          <input
                            type="checkbox"
                            id="input-tc"
                            className="absolute w-0 h-0 peer"
                          ></input>
                          <label
                            htmlFor="input-tc"
                            className="py-2 text-black text-13 pl-7"
                          >
                            TC Vatandaşı Değilim
                          </label>
                          <span className="absolute left-0 w-5 h-5 mt-1 transition-colors border-2 rounded-sm pointer-events-none border-brand-gray-8 peer-checked:bg-brand-gray-8"></span>
                          <FaCheck
                            size={12}
                            className="absolute opacity-0 left-1 top-2 peer-checked:opacity-100"
                          ></FaCheck>
                        </div>
                      </div>
                      <TextInput
                        className="w-full py-3 text-sm font-semibold outline-none peer"
                        placeholder={"Tc No"}
                        name="identityNumber"
                        isrequired="required"
                      ></TextInput> */}
                    </div>
                  </div>

                  {/* Tab 2 */}
                  <PaymentOptions
                    reservationResult={reservationResult}
                    paymentType={page?.Product?.paymentType}
                  ></PaymentOptions>
                  {/* Tab 2 */}

                  {/* Tab 3 */}
                  <div className="mt-11">
                    <Title>{reservationSection3Title}</Title>
                    <div className="flex flex-col mt-5 gap-x-3 sm:flex-row">
                      <div className="flex flex-col flex-1 gap-y-3">
                        <div className="flex items-center justify-between bg-white rounded-md px-11 pt-7 pb-9">
                          <div className="flex flex-col">
                            <span className="mb-2 text-15 leading-[18px] mt-1">
                              {reservationDamageDeposit}
                            </span>
                            <p className="text-13 text-brand-gray-9 leading-[15px]">
                              {reservationDamageDepositDescription}
                            </p>
                          </div>
                          <span className="text-[15px]">
                            <DefaultCurrencyFormat
                              value={page.Product.hasar}
                              Symbol={page.Product.Symbol}
                            ></DefaultCurrencyFormat>
                          </span>
                        </div>
                        <div className="flex items-center bg-white rounded-md px-11 pt-7 pb-9">
                          <div className="flex flex-col">
                            <span className="mb-2 text-15 leading-[18px] mt-1">
                              {reservationCheckinCheckoutTime}
                            </span>
                            <div className="flex gap-x-[18px]">
                              <span className="font-semibold text-13 text-brand-gray-2">
                                {reservationCheckinTime}
                                <em className="text-sm not-italic text-brand-black-2">
                                  {page.Product.giris_saat}
                                </em>
                              </span>
                              <Icon name={"DatepickerMiddle"}></Icon>
                              <span className="font-semibold text-13 text-brand-gray-2">
                                {reservationCheckoutTime}
                                <em className="text-sm not-italic text-brand-black-2">
                                  {page.Product.cikis_saat}
                                </em>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w-full mt-3 sm:mt-0 sm:w-[342px] lg:w-[240px] xl:w-[342px] bg-white rounded-md px-11 pt-8 pb-10">
                        <span className="text-primary">{inludedPrice}</span>
                        <ul className="mt-3">
                          {page.Product.fiyata_dahil &&
                            page.Product.fiyata_dahil.map((v, i) => {
                              return (
                                <li
                                  key={i}
                                  className="leading-6 text-13 text-brand-gray-9"
                                >
                                  {v}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* Tab 3 */}

                  <div className="flex flex-col items-center gap-2 mt-14 lg:items-start">
                    <Contract
                      name="sozlesme"
                      text={contract1}
                      content={page.sozlesme.icerik}
                    ></Contract>

                    <Contract
                      name="kvkk"
                      text={contract2}
                      content={page.kvkk.icerik}
                    ></Contract>
                    <SendBtn
                      reservationResult={reservationResult}
                      a={props}
                    ></SendBtn>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
